import { render } from "./edifice.vue?vue&type=template&id=19d19ac3&scoped=true"
import script from "./edifice.vue?vue&type=script&lang=js"
export * from "./edifice.vue?vue&type=script&lang=js"

import "./edifice.vue?vue&type=style&index=0&id=19d19ac3&lang=scss&scoped=true"

import exportComponent from "/www/publicHouse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19d19ac3"]])

export default __exports__